import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Api as AdministrationApi } from 'src/app/api/administration/api';
import { Api as GseApi } from 'src/app/api/gse/api';
import {
  getUserDashboardSummary,
  GetUserDashboardSummary$Params,
} from 'src/app/api/administration/fn/user-dashboard/get-user-dashboard-summary';
import {
  getDeletationOverview,
  GetDeletationOverview$Params,
} from 'src/app/api/administration/fn/user-dashboard/get-deletation-overview';
import {
  getTechnicianEfficiency,
  GetTechnicianEfficiency$Params,
} from 'src/app/api/gse/fn/maintenance-dashboard/get-technician-efficiency';
import { TechnicianEfficiencyResponse } from 'src/app/api/gse/models/technician-efficiency-response';
import { UserDashboardSummaryResponse } from 'src/app/api/administration/models/user-dashboard-summary-response';
import { DelegationOverviewDashboardResponse } from 'src/app/api/administration/models/delegation-overview-dashboard-response';

@Injectable({ providedIn: 'root' })
export class AdministrationUserDashboardService {
  private readonly administrationApi = inject(AdministrationApi);
  private readonly gseApi = inject(GseApi);

  getUserSummary(
    params?: GetUserDashboardSummary$Params
  ): Observable<UserDashboardSummaryResponse> {
    return from(this.administrationApi.invoke(getUserDashboardSummary, params ?? {}));
  }

  getDelegationOverview(
    params: GetDeletationOverview$Params
  ): Observable<DelegationOverviewDashboardResponse> {
    return from(this.administrationApi.invoke(getDeletationOverview, params));
  }

  getTechnicianLeaderboard(
    params: GetTechnicianEfficiency$Params
  ): Observable<TechnicianEfficiencyResponse> {
    return from(this.gseApi.invoke(getTechnicianEfficiency, params));
  }
}

